import { v4 as uuidv4 } from "uuid";
export class CalendarEventViewModel {
    constructor() {
        this.id = uuidv4();
        this.title = "";
        this.start = "";
        this.url = "";
        this.className = "";
    }
}
export default class CalendarEventView extends CalendarEventViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
